/* ============================================================
   Shared motion tokens — single source of truth for the
   "refined & cinematic" animation feel across the site.
   ============================================================ */

/** Calm, premium ease-out cubic-bezier. */
export const EASE_OUT: [number, number, number, number] = [0.22, 1, 0.36, 1];

/** Standard durations (seconds). */
export const DURATION = {
  section: 0.7,
  item: 0.5,
  text: 0.6,
};

/** Default vertical/horizontal travel distance for reveals (px). */
export const TRAVEL = 24;

/** Stagger gap between sibling items (seconds). */
export const STAGGER = 0.08;

/** Default whileInView viewport config — fire once, when ~25% visible. */
export const VIEWPORT = { once: true, amount: 0.25 } as const;
